import React from 'react';
import style from './style.module.scss';
import PropTypes from 'prop-types';

const Modal = ({
    onDismiss = () => { },
    children = null
}) => {
    return (
        <div className={style.wrapper}>
            <div className={style.children}>{children}</div>
            <div className={style.clickable} onClick={onDismiss}></div>
        </div>
    );
};

Modal.propTypes = {

};

export default Modal;